export enum ProjectOAuth2GitHubPrompt {
    SelectAccount = 'select_account',
}
